import { render, staticRenderFns } from "./GroupSettings.vue?vue&type=template&id=9a4c10fa&"
import script from "./GroupSettings.vue?vue&type=script&lang=js&"
export * from "./GroupSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports